import request from "@/config/utils/request";
// 校验是否为应用管理员账户
export function checkLogin(data) {
  return request({
    url: "/apis/demo/applyActivate/checkLogin",
    method: "post",
    data
  });
}
// 保存应用的属性
export function saveInfo(data) {
  return request({
    url: "/apis/demo/applyActivate/saveAppConfig",
    method: "post",
    data
  });
}
// 获取审批流程列表
export function getCheckList(data) {
  return request({
    url: "/apis/demo/applyActivate/getActivateData ",
    method: "post",
    data
  });
}
